import React, { useState, useRef } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import { CircularProgress, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import * as langUtils from '../../../../../../lib/languageUtils.es6';
import { getEnviroment } from '../../../../../../lib/utils.es6';
import { preloadAdminBundle } from '../../../../../../lib/bundlePreloader';
import { useStyle } from './Style';
import AspinLogo from '../../../../../../Assets/logo.png';
import OtpForm from '../../../../components/OtpForm';

function LoginForm(props) {
  const classes = useStyle();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showUsernameError, setShowUsernameError] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState(false);

  const preloadStarted = useRef(false);

  const triggerPreload = function() {
    if (!preloadStarted.current) {
      preloadStarted.current = true;
      preloadAdminBundle();
    }
  };

  const handleClickShowPassword = function() {
    setShowPassword(function(prev) {
      return !prev;
    });
  };

  const handleMouseDownPassword = function(event) {
    event.preventDefault();
  };

  const handleUsername = function(e) {
    setUsername(e.target.value);
    setShowUsernameError(false);
    triggerPreload();
  };

  const handlePassword = function(e) {
    setPassword(e.target.value);
    setShowPasswordError(false);
    triggerPreload();
  };

  const login = function() {
    if (!username) {
      setShowUsernameError(true);
      return;
    }
    if (!password) {
      setShowPasswordError(true);
      return;
    }
    props.login({ username, password });
  };

  const onSelectLanguage = function(event) {
    props.updateGlobalLanguage(event.target.value);
  };

  const handleKeyDown = function(e) {
    if (e.key === 'Enter') {
      login();
    }
  };

  const environment = getEnviroment();
  const isOnTestEnvironment =
    ['dev', 'staging'].indexOf(environment) !== -1;

  return (
    <div className={classes.card}>
      <div className={classes.cardHeader}>
        <img src={AspinLogo} alt="ASPin logo" />
      </div>
      {isOnTestEnvironment && (
        <p className={classes.testBanner}>
          WELCOME TO THE TEST ENVIRONMENT
        </p>
      )}
      <div className={classes.cardBody}>
        {props.mfaPending ? (
          <OtpForm
            pendingAuthToken={props.pendingAuthToken}
            maskedEmail={props.maskedEmail}
            loading={props.mfaLoading}
            error={props.mfaError}
            resent={props.mfaResent}
            onVerify={props.onVerify}
            onResend={props.onResend}
            onCancel={props.onCancel}
            verifyButtonStyle={{
              backgroundColor: '#009677',
              color: '#FFFFFF',
              height: '48px',
              fontWeight: '700',
              borderRadius: '8px',
            }}
          />
        ) : (
          <>
            <Grid container>
              <Grid item xs={12}>
                {showUsernameError && (
                  <p className={classes.errorText}>Please enter username</p>
                )}
                <TextField
                  required
                  id="om-username"
                  label={props.labels ? props.labels.username : 'Username'}
                  type="text"
                  variant="outlined"
                  value={username}
                  onChange={handleUsername}
                  onKeyDown={handleKeyDown}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ className: classes.input }}
                  className={classes.loginforms}
                />
              </Grid>
              <Grid item xs={12}>
                {showPasswordError && (
                  <p className={classes.errorText}>Please enter password</p>
                )}
                <TextField
                  required
                  id="om-password"
                  label={props.labels ? props.labels.password : 'Password'}
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  value={password}
                  onChange={handlePassword}
                  onKeyDown={handleKeyDown}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  className={classes.loginforms}
                  InputProps={{
                    className: classes.input,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} className={classes.languageRow}>
                <FormControl fullWidth>
                  <InputLabel
                    sx={{ fontFamily: 'Open Sans', fontSize: '14px' }}
                    id="om-language-label"
                  >
                    {props.labels
                      ? props.labels.selectLanguage
                      : 'Select Language'}
                  </InputLabel>
                  <Select
                    labelId="om-language-label"
                    id="om-language-select"
                    value={props.language}
                    label="Select Language"
                    onChange={onSelectLanguage}
                  >
                    {langUtils.availableLanguages().map(function(lang) {
                      return (
                        <MenuItem
                          key={lang.value}
                          sx={{ fontFamily: 'Open Sans', fontSize: '14px' }}
                          value={lang.value}
                        >
                          {lang.display}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <div className={classes.forgotPassword}>
              <span onClick={props.forgetpassword}>
                {props.labels
                  ? props.labels.forgotPassword
                  : 'Forgot password?'}
              </span>
            </div>

            {props.loginError && (
              <p className={classes.errorText}>{props.loginError}</p>
            )}

            <button
              className={classes.loginBtn}
              onClick={login}
              type="button"
            >
              {props.loading ? (
                <CircularProgress size={22} style={{ color: '#fff' }} />
              ) : props.labels ? (
                props.labels.submitLogin
              ) : (
                'Sign In'
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default LoginForm;
